
const Footer = () => {

    return (
        <footer className="my-4">
            <div className="row">
                <div className="mt-1 col-md-12">
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="text-muted col-md-10"><small>This site is maintained by SF3 – Society for the Furtherance &amp; Study of Fantasy &amp; Science Fiction</small></div>
                <div className="col-md-1"><small><a href="http://wiscon.net/policies/privacy/" className="text-muted">Privacy</a></small></div>
                <div className="col-md-1"><small><a href="http://wiscon.net/contact/" className="text-muted">Contact</a></small></div>
            </div>
        </footer>
    );
}

export default Footer;